module.exports = "<div :class=\"['collapsible-header', active ? 'active' : '']\"> <mui-icon v-if=icon :value=icon :class=iconPosition></mui-icon> {{label}} </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/collapsible/collapsible-header.vue
 ** module id = 90
 ** module chunks = 0
 **/